<template>
  <div class="box5">
    <pageTitle
      title="从0到1全流程实践主流行业项目<br/>积累高质量企业项目经验"
      text="多场景+高价值  强化实战能力对标大厂优秀人才标准"
    />

    <div class="subject-content">
      <div class="left">
        <p>项目领域</p>
        <p>项目优势</p>
      </div>
      <div class="right">
        <div class="firstRow">
          <div class="item" v-for="(item, index) in list[0]" :key="index">
            {{ item }}
          </div>
        </div>
        <div class="secondRow" ref="content">
          <div class="item" v-for="(item, index) in list[1]" :key="index">
            {{ item }}
          </div>
        </div>
      </div>
      <!-- <div class="scorll-box">
        <div class="scorll-block" :style="styleVar"></div>
      </div> -->
    </div>

    <div class="subject-box">
      <!-- <div class="scorll-box6">
        <div class="nav-box">
          <div
            class="nav"
            :class="{ 'cur-nav': cur == index }"
            v-for="(item, index) in projectList"
            :key="index"
            @click="changeCur(index)"
          >
            {{ item.name }}
          </div>
        </div>
      </div> -->
      <div >
        <swiper :options="swiperOption" ref="mySwiper" class="swiperitems">
          <swiper-slide
            class="swiperwrap"
            v-for="(item, index) in projectList"
            :key="index"
          >
            <div class="wrap">
              <div class="top" @click="viewVideo(item)">
                <div class="projectName">{{ item.title }}</div>
                <img class="img" :src="item.img" alt="" />
                <img v-if="item.link" class="video" src="../../../assets/coursePage/java/box5/video.png"/>
              </div>
              
             
              <div class="projectDesc" @click="showPop">{{ item.intro }}</div>
              <div class="btn" @click="showPop">查看全部</div>
            </div>
          </swiper-slide>
        </swiper>
        <div class="swiper-pagination-box2"></div>
      </div>

      <!-- <div class="swiper-pagination-box5"></div> -->
    </div>

    <van-popup v-model="show" position="bottom" round>
      <div class="block">
        <div class="block-tops">
          <div class="title">{{ projectList[this.cur].title }}</div>
          <div class="close" @click="show = false"></div>
        </div>

        <!-- <div class="exp">{{ projectList[this.cur].exp }}</div> -->

        <div class="intro">{{ projectList[this.cur].intro }}</div>

        <!-- <div class="tag">学习收获</div>
        <div class="target">
          <p v-for="j in projectList[this.cur].get" :key="j">{{ j }}</p>
        </div> -->
      </div>
    </van-popup>
     <CourseVideo :src="videoSrc" :flag="videoFlag" @close="close" specialStyle="2" autoplay="true"></CourseVideo>
  </div>
</template>

<script>
import pageTitle from "../common/pageTitle.vue";
import { swiper, swiperSlide } from "vue-awesome-swiper";
import CourseVideo from "../common/courseVideo.vue";
import "swiper/dist/css/swiper.css";

export default {
  components: {
    pageTitle,
    CourseVideo,
    swiper,
    swiperSlide,
  },
  mounted() {},

  data() {
    let that = this;
    return {
       videoSrc: '',
      videoFlag: false,
      show: false,
      list: [
        [
          "项目领域",
          "出行",
          "社交",
          "新零售",
          "物联网",
          "物流",
          "金融",
          "家政",
          "新闻资讯",
          "教育",
          "养老",
        ],
        [
          "项目优势",
          "共同研发",
          "技术成熟",
          "价值稀缺",
          "斥资投入",
          "对标大厂",
          "多领域",
          "好就业",
          "深度解决",
          "热门行业",
          "主流技术",
          "还原场景",
        ],
      ],
      projectList: [
        {
          name: "项目一",
          title: "中州养老",
          link:'https://file.boxuegu.com/bxgyingxiao/%E4%B8%AD%E5%B7%9E%E5%85%BB%E8%80%81.mp4',
          img: require("../../../assets/coursePage/java/box5/1.png"),
          intro:
            "中州养老是一款智能化养老服务管理系统，涵盖了智能健康监测、工作流审批、权限管理、订单管理等多个功能模块，旨在为养老服务机构提供信息化管理方案，同时实时掌握老人的健康状况和护理情况，提高服务质量，减少管理成本。",

          get: [
            "课程全程采用 AI 工具辅助开发。",
            "课程讲解重点培养系统设计能力，包含了数据库设计、接口设计、技术方案设计等。",
            "课程采用低代码平台若依框架，实现快速开发和部署。",
            "课程中对接了百度千帆大模型，为解决实际业务挑战提供高效助力。",
            "课程包含了前端 Vue3+Element plus 组件完成页面开发，助你向全栈工程师靠拢。",
            "通过开发复杂业务，让你具备性能优化、接口优化、SQL 优化的能力，使系统更高效。",
            "注重代码质量，选择合适的设计模式调整代码结构，让你的代码更简洁，易扩展。",
            "采用了 RBAC 模型+Spring security 完成权限认证，让你掌握后台管理系统权限的通用解决方案。",
            "……"
          ],
        },
       
        {
          name: "项目二",
          title: "云岚到家",
          link:"https://file.boxuegu.com/bxgyingxiao/%E4%BA%91%E5%B2%9A%E5%88%B0%E5%AE%B6.mp4",
          img: require("../../../assets/coursePage/java/box5/2.png"),
          intro:
            "云岚到家是一个基于移动互联网的O2O家政服务平台，它连接家政服务提供者和有需求的用户，平台包括四个端：用户端、服务端、机构端和管理端，实现了线上预订、接单、派单等功能，为用户提供便捷、高效的家政服务体验。",
          get: [
            "学员实战时可采用AI助手辅助开发，包括AI辅助设计、AI编码、AI代码审查、AI单元测试、AI代码优化等，大幅度提升开发效率。",
"项目采用主流的SpringBoot、Spring Cloud Alibaba技术栈，适用于大多数企业对单体项目及微服务项目的技术选型，学完可快速应用到企业开发中。",
"课程内容全面，包括：需求分析、设计、开发、测试、系统优化、运维等，学完将掌握Java中高级程序员在整个项目生命周期中所具备的重要技能。",
"课程采用渐进式设计模式，保证零基础小白从入门到精通循序渐进掌握大型项目的实战能力。",
"课程采用多项目教学，课堂授课与项目实战共涉及五个项目十几个业务模块，注重业务领域的深度学习及业务领域的迁移训练；注意业务解决方案与技术解决方案融合，讲授二十余个技术方案且通用性强，适合进行技术方案迁移。"
          ],
        },
        {
          name: "项目三",
          title: "天机学堂",
         link:"https://file.boxuegu.com/bxgyingxiao/%E5%A4%A9%E6%9C%BA%E5%AD%A6%E5%A0%82.mp4",
          img: require("../../../assets/coursePage/java/box5/3.png"),
          intro:
            "天机学堂是⽣产级的在线教育项⽬，是专注于⾮学历职业技能培训的“⽹校”。项⽬基于SpringCloudAlibaba微服务技术栈，包含在线教育、社交、电商等热点难点问题的企业解决⽅案，让学⽣真正做到举⼀反三。项⽬的完整度⾼，教学过程遵循企业开发流程，旨在让学⽣体会真实企业开发，掌握微服务开发的常⽤技能。",
          get: [
            "掌握企业开发的基本模式",
              "了解企业开发环境、持续集成环境的⼯作模式",
              "掌握跨微服务的业务开发⽅式",
              "学会基于产品原型和需求做业务流程分析",
              "学会基于产品原型和需求做数据结构设计",
              "学会基于产品原型和需求做接⼝设计",
              "掌握在线教育项⽬中的学习辅助系统设计⽅案",
              "掌握积分、排⾏榜等系统设计⽅案",
              "掌握优惠券系统设计⽅案",
              "掌握常⽤中间件在微服务开发中的各种使⽤⽅式",
          ],
        },
        {
          name: "项目四",
          title: "四方保险",
         
          img: require("../../../assets/coursePage/java/box5/4.png"),
          intro:
            "四方保险项目是一个金融保险销售SAAS平台，依托移动互联网项目为保险销售公司、保险产品需求人提供线上保险销售、产品发布、产品推荐、自动保费计算、收益计算、核保、承保、理赔等业务。",
          get: [
            "掌握微服务项目业务需求分析能力", 
            "掌握微服务项目模块的拆分设计能力 ", 
            "掌握SpringCloud的企业级开发框架的应用能力", 
            "掌握SpringCache+Redis的优雅的缓存处理能力", 
            "掌握保险产品组合系数发布处理", 
            "掌握保前保费计算、收益试算业务", 
            "掌握使用规则引擎做保前初筛、产品推荐业务", 
            "掌握生成保险合同、合同分期支付计划业务", 
            "构建基于OAuth2.0的微服务权限统一管理", 
            "构建基于多个三方的对象存储微服务平台",  
            "构建基于微信、支付宝多场景的统一支付微服务平台",  
            "构建基于阿里云、百度云、腾讯云的统一短信微服务平台",  
            "构建基于Gateway+influxDB的数据采集分析平台",
          ],
        },
        {
          name: "项目五",
          title: "帝可得",
         link:"https://file.boxuegu.com/bxgyingxiao/%E5%B8%9D%E5%8F%AF%E5%BE%97%E9%A1%B9%E7%9B%AE.mp4",
          img: require("../../../assets/coursePage/java/box5/5.png"),
          intro:
            "帝可得是⼀个智能售货机项⽬，基于SpringCloud+MybatisPlus框架开发，并应⽤传智研究院⾃研的解决⽅案框架集 Elegent 解决接⼝幂等性、数据⼀致性、分布式锁、分布式事务、微服务模块解耦与异步调⽤，⽀付、权限、Token续期等企业开发中的通⽤问题。",
          get: [
            "了解需求评审会的场景与常⻅问题",
            "根据产品原型分析和理解项⽬整体需求",
            "基于库表设计⽅法论进⾏库表设计",
            "根据产品原型进⾏接⼝设计",
            "熟练编写跨服务调⽤代码",
            "熟练编写微服务异步调⽤的代码，理解ElegentAC框架的设计原理",
            "掌握分布式事务的实现，理解ElegentACTX框架的设计原理",
            "熟练掌握分布式锁的实现，理解ElegentLock框架的设计原理",
            "……",
          ],
        },
      ],
      cur: 0,
      scroll: 0,
      swiperOption: {
        loop: true, // 循环模式选项
        slidesPerView: "auto",
        spaceBetween: 40,
        slidesPerView: "auto",
        centeredSlides: true,
        pagination: {
          el: ".swiper-pagination-box2",
        },
        on: {
          slideChangeTransitionStart: function () {
            that.cur = this.realIndex;
            // document.getElementsByClassName("nav-box")[0].scrollLeft =
            //   this.realIndex * 85;
          },
          click(e) {
            if (e.target.className == "open") {
              that.show = true;
            }
          },
        },
      },
    };
  },
  computed: {
    swiper() {
      return this.$refs.mySwiper.swiper;
    },

    styleVar() {
      return {
        "--box-left": this.scroll + "px",
      };
    },
  },
  methods: {
    close() {
      console.log('进来')
        this.videoSrc = ''
        this.videoFlag = false
    },
    viewVideo(item){
      if(item.link){
         this.videoSrc = item.link
        this.videoFlag = true
      }else{
        this.clickZiXun()
      }

    },
  showPop(){
  this.show = true,
       this.mai("JavaEE-就业课","查看全部",0,this.projectList[this.cur].title)
  },
    changeCur(index) {
      this.swiper.slideTo(index, 0, false);
      this.cur = index;
    },
    // close() {
    //   this.showVideo = false;
    // },
  },
};
</script>

<style lang="less" scoped>
.box5 {
  padding: 80px 0 0;
  width: 100%;
  background: url("../../../assets/coursePage/java/box5/bgc.png") no-repeat;
  background-size: cover;
  overflow: hidden;
  .van-popup {
    max-height: calc(100vh - 80px);
    min-height: 50vh;
  }
  .subject-content {
    overflow-x: scroll;
    width: 100%;
    height: 234px;
   
    display: flex;
    overflow-y: hidden;
    align-content: center;
    margin: 48px 0;
    .left {
      background: url("../../../assets/coursePage/java/box5/leftBgc.png")
        no-repeat;
      background-size: cover;
      width: 262px;

      height: 236px;
      flex-shrink: 0;
      p {
        height: 72px;
        width: auto;
        background-size: cover;
        box-shadow: 0px 0px 36px 0px rgba(20, 50, 74, 0.08);
        position: relative;
        margin-right: 20px;
        font-weight: 600;
        color: #165dff;
        border: 0;
        box-shadow: none;
        font-size: 28px;
        font-family: PingFang SC;
      }
      p:nth-child(1) {
        margin-left: 70px;
        margin-top: 53px;
      }
      p:nth-child(2) {
        margin-left: 70px;
        margin-top: 20px;
      }
    }
    .right {
      display: flex;
      align-content: center;
      flex-wrap: wrap;
    }
    .firstRow,
    .secondRow {
      position: relative;
      display: flex;
      margin-left: -20px;
      .item {
        flex-shrink: 0;
        height: 72px;
        background: rgba(255, 255, 255, 0.4);
        box-shadow: 0px 0px 36px 0px rgba(20, 50, 74, 0.08);
        border-radius: 8px;

        padding: 0 36px;
        font-size: 28px;
        font-family: PingFang SC;
        font-weight: 400;
        color: #4e5969;
        margin-right: 20px;
        line-height: 72px;
      }
    }
    .secondRow {
      margin-top: 20px;
      margin-right: 20px;
    }
  }
  .subject-content::-webkit-scrollbar {
    display: none;
    width: 0 !important;
    height: 0 !important;
    color: transparent;
  }
  .nav-box::-webkit-scrollbar {
    display: none;
    width: 0 !important;
    height: 0 !important;
    color: transparent;
  }
  .scorll-box {
    position: absolute;
    left: 50%;
    margin-top: 32px;
    transform: translate(-50%, 0px);
    width: 78px;
    height: 6px;
    background: rgba(75, 132, 250, 0.16);
    border-radius: 3px;
    .scorll-block {
      position: absolute;
      left: var(--box-left);
      width: 20px;
      height: 6px;
      background: #4b84fa;
      border-radius: 3px;
    }
  }
  .subject-box {
    position: relative;
    margin: 10px auto 0;
    // padding-bottom: 22px;
    width: 100%;
    overflow: hidden;
    .swiperwrap {
      width: 686px;
      .top{
        background: linear-gradient( 180deg, #1781F1 0%, #5FC5FF 100%);
        border-radius: 20px;
        padding:36px;
        position:relative;
        .video{
          width: 94px;
          position: absolute;
          top: 58%;
          left: 50%;
          transform: translate(-50%,-50%);
        }
      }
      margin-top: 8px;
      .img {
        width: 100%;
       
        object-fit: cover;
        border-radius: 16px;
      }
      .projectName {
        height: 48px;
        font-family: PingFangSC, PingFang SC;
font-weight: 600;
font-size: 32px;
color: #FFFFFF;
line-height: 48px;
text-align: left;
font-style: normal;

        margin: 4px auto 28px;
      }
      .projectDesc {
        font-size: 28px;
        font-family: PingFang SC;
        font-weight: 400;
        color: #86909c;
        line-height: 44px;
        margin-top: 32px;
        height: 160px;
        background: linear-gradient(
          180deg,
          #86909c 0%,
          rgba(134, 144, 156, 0) 100%
        );
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
      }
      .btn {
        width: 180px;
        height: 56px;
        background: linear-gradient(270deg, #4eacff 0%, #2674ff 100%);
        border-radius: 32px;
        font-size: 24px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #ffffff;
        line-height: 56px;
        text-align: center;
        margin: 24px auto 14px;
      }
    }

    .scorll-box6 {
      overflow-x: scroll;
      transition: all 0.2s;
      width: 100%;

      box-sizing: border-box;
      &::-webkit-scrollbar {
        display: none;
        width: 0 !important;
        height: 0 !important;
        color: transparent;
      }
    }
    .nav-box {
      height: 96px;
      display: flex;
      justify-content: space-between;

      position: relative;
      font-family: PingFang SC;
      font-size: 24px;
      font-weight: 400;
      color: #1d2129;
      display: flex;
      justify-content: space-between;
      overflow-x: scroll;
      transition: all 0.2s;
      padding: 0 32px 0 32px;
      .nav {
        width: 138px;
        height: 68px;
        background: #ffffff;
        border-radius: 8px;
        font-size: 26px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #4e5969;
        line-height: 68px;
        text-align: center;
        margin-right: 20px;
        flex-shrink: 0;
      }

      .cur-nav {
        background: linear-gradient(224deg, #37abff 0%, #3d8efd 100%);

        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: 600;
        color: #ffffff;

        position: relative;
      }
    }
  }

  .swiper-slide {
    // padding: 0px 40px;
    padding-bottom: 112px;

    .block {
      position: relative;
      margin: 0 auto;
      padding: 36px 32px;
      width: 686px;
      height: 688px;
      background: #ffffff;
      box-shadow: 4px 8px 20px 0px rgba(0, 0, 0, 0.04);
      border-radius: 20px;
      border: 1px solid #ffffff;
      background-size: contain;
      background-repeat: no-repeat;
      // box-sizing: border-box;

      .open {
        position: absolute;
        left: 0;
        bottom: 0;
        display: flex;
        justify-content: center;
        align-items: center;
        padding-top: 30px;
        width: 100%;
        height: 140px;
        // background: #fff;
        background: linear-gradient(
          180deg,
          rgba(255, 255, 255, 0) 0%,
          #ffffff 40%,
          #fff 100%
        );
        font-size: 24px;
        font-family: PingFang SC;
        font-weight: 400;
        color: #86909c;
        line-height: 36px;
        box-sizing: border-box;

        img {
          margin-left: 8px;
          width: 32px;
          height: 32px;
        }
      }

      overflow: hidden;
      box-sizing: border-box;

      .block-top {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 20px;
        height: 56px;
        .title {
          font-size: 28px;
          font-family: PingFangSC-Semibold;
          font-weight: 600;
          color: #1d2129;
        }

        .play-btn {
          display: flex;
          align-items: center;
          width: 180px;
          height: 56px;
          background: linear-gradient(313deg, #1fd7cd 0%, #65bcff 100%);
          box-shadow: 0px 8px 24px 0px rgba(64, 128, 255, 0.12);
          border-radius: 32px;

          font-size: 24px;
          font-family: PingFangSC-Medium;
          font-weight: 500;
          color: #ffffff;

          .play {
            margin-left: 8px;
            margin-right: 12px;
            width: 40px;
            height: 40px;
            background-color: #ffffff;
            border-radius: 50%;
            box-shadow: 0px 0px 6px 0px #28a9ea;
            background-image: url("../../../assets/coursePage/ai/box8/play.png");
            background-size: 24px 24px;
            background-repeat: no-repeat;
            background-position: center;
          }
        }
      }

      .into {
        margin-bottom: 24px;
        font-size: 24px;
        font-family: PingFang SC;
        font-weight: 400;
        color: #4e5969;
        line-height: 40px;
      }
    }
  }

  .swiper-pagination-box2 {
    display: flex;
    align-items: center;
    position: absolute;
    left: 50%;
    bottom: 80px;
    transform: translate(-50%, 0px);
    height: 6px;
    transform: translate(-50%, 0px);
    background: rgba(75, 132, 250, 0.16);

    border-radius: 3px;
  }

  /deep/ .swiper-pagination-bullet {
    width: 20px;
    height: 6px;
    background: rgba(75, 132, 250, 0.16);
    border-radius: 3px;
  }

  /deep/.swiper-pagination-bullet.swiper-pagination-bullet-active {
    width: 20px;
    height: 6px;
    background: #4b84fa;
    border-radius: 3px;
  }

  .block {
    position: relative;
    margin: 0 auto;
    padding-top: 0px;
    padding: 0 56px;
    // padding-top: 128px;

    // height: 640px;
    background: #ffffff;
    // box-shadow: 4px 8px 20px 0px rgba(0, 0, 0, 0.04);
    border-radius: 20px;
    // border: 1px solid #ffffff;

    box-sizing: border-box;

    .block-tops {
      position: sticky;
      top: 0px;
      display: flex;
      justify-content: space-between;
      align-items: center;

      width: 100%;
      height: 132px;
      padding-top: 16px;
      background: #fff;
      box-sizing: border-box;
      .title {
        font-size: 36px;
        font-family: PingFangSC-Semibold;
        font-weight: 600;
        color: #1d2129;
      }
      .close {
        width: 32px;
        height: 32px;
        background: url("../../../assets/coursePage/ai/box8/close.png")
          no-repeat;
        background-size: cover;
      }
    }
    .exp {
      font-size: 26px;
      font-family: PingFangSC-Semibold, PingFang SC;
      font-weight: 600;
      color: #1d2129;
      line-height: 44px;
      margin-bottom: 8px;
    }
    .intro {
      margin: 0px 0 40px;
      font-size: 26px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #4e5969;
      line-height: 44px;
    }

    .demo {
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;

      font-size: 28px;
      font-family: PingFang SC;
      font-weight: 400;
      color: #4e5969;
      line-height: 40px;
      p {
        display: flex;
        align-items: center;

        span {
          margin-right: 8px;
          width: 8px;
          height: 8px;
          border-radius: 50%;
          background: #00a8ff;
        }
      }
    }

    .tag {
      margin-bottom: 24px;
      width: 170px;
      height: 56px;
      background: #e8f1ff;
      border-radius: 0px 32px 32px 24px;
      font-size: 28px;
      font-family: PingFangSC-Medium;
      font-weight: 500;
      text-align: center;
      color: #2674ff;
      line-height: 56px;
    }

    .target {
      margin-bottom: 64px;
      font-size: 26px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #4e5969;
      line-height: 44px;
      p {
         padding-left: 15px;
          position: relative;
        &::before {
          content: "";
          width: 4px;
          height: 4px;
          background: #4e5969;

          border-radius: 50%;

          top: 20px;
          display: block;
          position: absolute;
          left: 0;
        }
      }
    }
  }
}
</style>
